export default __webpack_public_path__ + "static/media/CD.fff14559.svg";